import { render } from "./DeleteConfirm.3.vue?vue&type=template&id=52910e14&ts=true"
import script from "./DeleteConfirm.3.vue?vue&type=script&lang=ts"
export * from "./DeleteConfirm.3.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__